import { useParams } from "react-router-dom";
import { useTenant } from "../hooks/useTenant";
import { VocabularyEditor } from "../components/editor/VocabularyEditor";
import { colors } from "../lib/tokens";

export function TenantVocabularyPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const { tenant, loading } = useTenant(slug);
  if (loading || !tenant) return <div style={{ color: colors.stone }}>Carregando...</div>;
  return <VocabularyEditor tenantId={tenant.id} />;
}
